<!-- HEADING PART -->
<p-card>
    <div class="grid" >
      
      <div class="col-12 md:col-12 lg:col-12 createnewbtn">
          <div class="text-end p-0 border-round-sm font-bold" >
           
            <!-- <p-button *ngIf="loginuserid==0"  pTooltip="Add Organization" tooltipPosition="left" (click)="openmodal('Add an Organisation','')" styleClass="customAdd p-button-sm p-button-raised mr-1" icon="pi pi-plus"></p-button> -->
            
        <p-button (click)="openmodal('Add an Organisation','')" styleClass="customAdd p-button-sm p-button-raised mr-1"
          icon="fa fa-plus" pTooltip="Add Organization" tooltipPosition="left" *ngIf="loginuserid==0"></p-button>
            <button type="button" class="fa fa-question helpicon"(click)="helpservice.openhelpmodal(ref,dialogService,'Organisation Help',18,22)" pTooltip="Help" tooltipPosition="bottom"></button>        
          </div>
       
      </div>
     
    </div>
  
    <div class=" mr-0 tablehiegt">
      <p-table #dt [value]="tableData"[rows]="rows2" [scrollable]="true" scrollDirection="horizontal" 
       scrollHeight="{{commonScrollHeight}}" (sortFunction)="customSort($event)" [customSort]="true" 
        [globalFilterFields]="['orgid','name','orgtype','orginitial','enterprise','createddate']"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true" [showCurrentPageReport]="true"
        paginatorLocale="fa-IR" [paginator]="true" [lazy]="true"[totalRecords]="totalRecords" (onLazyLoad)="getgriddatalazy($event)" responsiveLayout="scroll"
         [sortField]="sortfield" [sortOrder]="sortorder" [resizableColumns]="true" columnResizeMode="expand"
          >
        <!-- search -->
        <ng-template pTemplate="caption">
          <div class="grid table-header">
              <div class="col-12 md:col-10 sm:col-12 lg:col-10">
                <span class=" p-input-icon-lft">
                  <i icon="pi pi-search"></i>
                  <input class="form-control" pInputText type="text" id="tablesearch"
                    (input)="dt.filterGlobal($any($event.target).value , 'contains')"
                    placeholder="Search in Organisation" class="tablesearch" pTooltip="Enter Search Criteria"
                    tooltipPosition="top" />
                </span>
              </div>
              <div class="col-12 sm:col-2 md:col-2 sm:col-12 displayflex " *ngIf="loginuserid==0 || bdteam">
                 <span>
                <div class="iconexcel" pTooltip="Organization details data download"
                tooltipPosition="bottom" style="cursor: pointer;" (click)="superadmingridexceDownloadModel()" ></div></span>
                <span>
                <div class="iconexcel" pTooltip="License Changes Data Download"
                tooltipPosition="bottom" style="cursor: pointer;" (click)="exceDownloadModel()" ></div></span>
              </div>
            </div>
        </ng-template>
  
        <ng-template pTemplate="header">
          <tr>
            <th class="tableaction" pResizableColumn>Action</th>
            <ng-container *ngFor="let col of _selectedColumns">
              <th [pSortableColumn]="col.field" *ngIf="col.isChecked" pResizableColumn>
                {{col.header}}<p-sortIcon [field]="col.field" ></p-sortIcon>
                <p-columnFilter type="text" [field]="col.field" display="menu"></p-columnFilter>
  
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
          <tr>
            <td>
              <div style="display: flex;">
                <span  *ngIf="loginuserid==0"class="actionItm" pTooltip="Modify" tooltipPosition="left"> <i class="fa fa-edit"
                    (click)="openmodal('Modify Organisation',data)"></i></span>
                <span  *ngIf="bdteam"class="actionItm" pTooltip="Modify" tooltipPosition="left"> <i class="fa fa-edit"
                    (click)="openmodal('Modify License Detail',data)"></i></span>                           
                <span class="actionItm" pTooltip="View" tooltipPosition="left"> <i class="fa fa-eye"
                    (click)="openmodal('View Organisation',data)"></i></span>                    
                <span *ngIf="loginuserid==0" class="actionItm" pTooltip="Product Wise Email Setting" tooltipPosition="left"> <i class="fa fa-envelope"
                    (click)="openmodal('Product Wise Email Status',data)"></i></span>
                      <span *ngIf="loginuserid == 0 || orgid == 1 || isSupportAdmin == 'Y'" class="orgband-badge"
                  [ngClass]="{
                    'orgband-p': data.orgband === 'Platinum',
                    'orgband-s': data.orgband === 'Silver',
                    'orgband-g': data.orgband === 'Gold'
                  }"
                  pTooltip="{{data.orgband}}"
                  tooltipPosition="top">
              {{ data.orgband?.charAt(0) }}
            </span>


                       <!-- <span *ngIf="bdteam" class="actionItm" pTooltip="Businesss User Modify" tooltipPosition="left"> <i class="fa fa-edit"
                      (click)="bdusermodalopen('Modify Organisation',data)"></i></span> -->
              </div>
            </td>
            <ng-container *ngFor="let col of _selectedColumns" >
              <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class"  >
                <span *ngIf=" col.type!=='date'"  pTooltip=" {{data[col.field] }}"tooltipPosition="left" >  {{data[col.field] }}</span>

          <span *ngIf="col.type=='date'" pTooltip=" {{data[col.field] | date: 'dd-MMM-YYYY' }}"> {{data[col.field] | date: 'dd-MMM-YYYY' }}</span>

                <!-- <span *ngIf="col.field=='enterprise'" >
                  <span *ngIf="data[col.field]=== 'C'" pTooltip="Cloud"tooltipPosition="left" >Cloud</span>
                  <span *ngIf="data[col.field]=== 'Y'"  pTooltip="Enterprise"tooltipPosition="left">Enterprise</span>

                 </span> -->
              </td>
            </ng-container>
          </tr>
        </ng-template>
             <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="_selectedColumns.length + 1"  class="datanotfound">
                No data available
            </td>
        </tr>
    </ng-template>
      </p-table>
    </div>
 
  </p-card>
   
       
    


  
 
        
    
    
    